<div class="row">
  <div class="col mx-auto">
    <app-generic-filterable-list
      [rows]="rows"
      [loading]="loading"
      [totalPages]="totalPages"
      [showInPage]="showInPage"
      (checkFilterChange)="checkFilterChange($event)"
      (selectedRow)="onSelect($event)"
      [noResultsText]="searchIsActive || filteringIsActive ? 'MANAGED_USERS.NO_DATA' : 'MANAGED_USERS.NO_USERS'"
      headerClass="filterable-list--header bg-white position-sticky"
      [scrollable]="false"
    >
    <ng-container appFilterableListColumn [grow]="3">
      <ng-template appFilterableListHeaderCell>
        <app-filterable-list-text-header [label]="'MANAGED_USERS.COLUMNS.NAME' | translate" />
      </ng-template>

      <ng-template [appFilterableListCell]="rows" let-row>
        <div class="d-flex align-items-center w-100">
          <img
            [src]="(row.profilePicture?.url ?? '/assets/images/user/user.png') | resizeImage: imageSizes.SIZE_64x64"
            class="w-2r h-2r rounded-circle me-2"
            draggable="false"
          />
          <span
            class="text-truncate"
            [title]="getUserName(row)"
            [innerHTML]="getUserName(row) | searchHighlight"
          ></span>
        </div>
      </ng-template>
    </ng-container>

      <ng-container appFilterableListColumn [grow]="3">
        <ng-template appFilterableListHeaderCell>
          <app-filterable-list-text-header [label]="'MANAGED_USERS.COLUMNS.EMAIL' | translate" />
        </ng-template>

        <ng-template [appFilterableListCell]="rows" let-row>
          <div class="d-flex align-items-center w-100">
            <span class="text-truncate" [title]="row.email" [innerHTML]="row.email | searchHighlight"></span>
          </div>
        </ng-template>
      </ng-container>

      <ng-container appFilterableListColumn [grow]="2">
        <ng-template appFilterableListHeaderCell>
          <app-filterable-list-checkbox-search
            [label]="'MANAGED_USERS.COLUMNS.STATUS' | translate"
            [paramName]="managedUserFilterParamEnum.STATUSES"
          >
            @for (status of [managedUserStatus.ACTIVE, managedUserStatus.BLOCKED]; track status) {
              <app-filterable-list-checkbox-option
                [value]="status"
                class="checkbox-dropdown-item"
              >
                <span class="color-black fs-4">{{ managedUserStatusTranslationMap[status] | translate }}</span>
              </app-filterable-list-checkbox-option>
            }
          </app-filterable-list-checkbox-search>

          <ng-template [appFilterableListCell]="rows" let-row>
            <app-tag [bgClass]="row.isActive ? 'bg-success-600' : 'bg-danger'"
              [icon]="row.isActive ? 'ni-tick-circle' : 'ni-not-interested'"
              [translationKey]="row.isActive ? 'MANAGED_USERS.ACTIVE' : 'MANAGED_USERS.BLOCKED'"
            />
          </ng-template>
        </ng-template>
      </ng-container>

      <ng-container appFilterableListColumn [grow]="2">
        <ng-template appFilterableListHeaderCell>
          <app-filterable-list-text-header [label]="'MANAGED_USERS.COLUMNS.DATE_CREATED' | translate" />
        </ng-template>
        <ng-template [appFilterableListCell]="rows" let-row>
          <span>
            {{ row.createdAt | i18nDate }}
          </span>
        </ng-template>
      </ng-container>

      <ng-container appFilterableListColumn [grow]="2">
        <ng-template appFilterableListHeaderCell>
          <app-filterable-list-text-header [label]="'MANAGED_USERS.COLUMNS.LAST_ACTIVE' | translate" />
        </ng-template>
        <ng-template [appFilterableListCell]="rows" let-row>
          <span>
            {{ row.lastSeen | i18nDate }}
          </span>
        </ng-template>
      </ng-container>

      <ng-container appFilterableListColumn [width]="'2rem'" [isActionsColumn]="true">
        <ng-template appFilterableListHeaderCell />
        <ng-template [appFilterableListCell]="rows" let-row>
          <app-managed-users-list-actions
            [row]="row"
            (resendPassword)="onResendPasswordLink($event)"
            (blockUser)="onSetUserBlocked($event, true)"
            (unblockUser)="onSetUserBlocked($event, false)"
          ></app-managed-users-list-actions>
        </ng-template>
      </ng-container>
    </app-generic-filterable-list>
  </div>
</div>
